import keyBy from 'lodash/keyBy';

import { SelectFieldOptionsType } from '@/types/schema';

const getSelectedOptions = (selectOptions: SelectFieldOptionsType[], value = '') => {
  const optionsById = keyBy(selectOptions, 'optionId');

  return value.split(',').reduce<SelectFieldOptionsType[]>((options, selectedOptionId) => {
    const selectedOption = optionsById[selectedOptionId];
    if (selectedOption) {
      options.push(selectedOption);
    }
    return options;
  }, []);
};

export default getSelectedOptions;
